<!-- <p>create-action works!</p> -->

<app-dialog-header *ngIf="!editing" headerIcon="content_paste" headerText="Create New Action"
    (onCloseClick)="onCancelClick()"></app-dialog-header>
<app-dialog-header *ngIf="editing" headerIcon="content_paste" headerText="Edit Action"
    (onCloseClick)="onCancelClick()"></app-dialog-header>
<div style="padding: 1em; width: 100%; width: 800px; max-height: 85vh; overflow-y: auto;" #DialogContainer
    id="DialogContainer">
    <div class="top-div">
        <span *ngIf="!editing" style="font-size: large; font-weight: bolder;">Create Action</span>
        <span *ngIf="editing" style="font-size: large; font-weight: bolder;">Edit Action</span>
        <span class="toolbar-spacer"></span>
        <button mat-raised-button (click)="skipAction()" *ngIf="!editing && attachedToEvent" cdkFocusInitial>
            <span>Skip</span>
            <mat-icon>east</mat-icon>
        </button>
    </div>
    <div class="action-content">
        <form [formGroup]="dialogForm" autocomplete="off">
            <div class="form-section-single" *ngIf="editing">
                <div class="form-box">
                    <ejs-dropdownlist [dataSource]='actionTypes' [enablePersistence]="true" placeholder="Action Type"
                        [fields]="actionTypeFields" formControlName="actionType">
                        <ng-template #itemTemplate let-data>
                            <div>
                                <span>{{ data.Description }}</span>
                            </div>
                        </ng-template>
                    </ejs-dropdownlist>
                </div>
            </div>
            <div class="form-section" *ngIf="!editing">
                <div class="form-box">
                    <ejs-dropdownlist [dataSource]='actionTypes' [enablePersistence]="true" placeholder="Action Type"
                        [fields]="actionTypeFields" formControlName="actionType" [readonly]="editing" popupWidth="150%">
                        <ng-template #itemTemplate let-data>
                            <div>
                                <span>{{ data.Description }}</span>
                            </div>
                        </ng-template>
                    </ejs-dropdownlist>
                </div>
                <div class="form-box rule-selection alignRow alignColumn"
                    style="border-left: 1px solid lightgray; border-top-left-radius: 0px; border-bottom-left-radius: 0px;">
                    <div>
                        <span>All Rules</span>
                        <mat-checkbox color="primary" (change)="toggleAllRule($event)"
                            [checked]="allSelected"></mat-checkbox>
                    </div>
                    <ejs-multiselect id='sample-list2' [mode]='mode' [fields]='ruleFields'
                        placeholder="Choose Rules to Disable" [showSelectAll]='true' [dataSource]="Rules"
                        formControlName="ruleList" (change)="multiSelectChange($event)"></ejs-multiselect>
                    <span></span>
                    <span>Rules to Disable</span>
                </div>
            </div>
            <div class="details-div">
                <mat-label>Details</mat-label>
                <textarea style="width: 100%;" matInput formControlName="details" maxlength="1000"></textarea>
                <mat-hint align="end">{{ getCommentLength() }}/{{1000}}</mat-hint>
            </div>
            <div class="form-section-triple alignRow">
                <div class="form-box">
                    <mat-form-field appearance="outline" subscriptSizing="dynamic"
                        style="padding-bottom: 0px !important;">
                        <mat-label>Work Order Reference</mat-label>
                        <input matInput autocomplete="off" formControlName="workOrderReference">
                    </mat-form-field>
                </div>
                <div class="form-box" *ngIf="accountUsers && accountUsers.length > 0"
                    style="border-left: 1px solid lightgray; border-top-left-radius: 0px; border-bottom-left-radius: 0px;">
                    <ejs-dropdownlist [dataSource]='accountUsers' [enablePersistence]="true"
                        placeholder="Assign to User" [fields]="accountUserFields" formControlName="assignedToUser">
                        <ng-template #itemTemplate let-data>
                            <div>
                                <span>{{ data.Name }}</span>
                            </div>
                        </ng-template>
                    </ejs-dropdownlist>
                </div>
                <div class="form-box"
                    style="border-left: 1px solid lightgray; border-top-left-radius: 0px; border-bottom-left-radius: 0px;">
                    <ejs-datepicker placeholder="Target Completion Date" [firstDayOfWeek]="1" format="dd-MM-yyyy"
                        [dayHeaderFormat]="'Abbreviated'" formControlName="targetCompletionTimestamp"
                        [readonly]="editing" [min]="today">
                    </ejs-datepicker>
                </div>
            </div>
        </form>
    </div>
    <!-- <div mat-dialog-actions>
        <button mat-button [mat-dialog-close]="dialogForm.value"
            [disabled]="dialogForm.invalid || !dialogForm.dirty ">Ok</button>
    </div> -->
    <div mat-dialog-actions>
        <button mat-button (click)="onDialogClose()" [disabled]="dialogForm.invalid || !dialogForm.dirty">Ok</button>
        <button *ngIf="!attachedToEvent" mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
    </div>
</div>